import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export const RequireAuth = ({ allowedRoles }) => {
    const { isAuthenticated, user, loading } = useAuth();
    const location = useLocation();

    if (loading) return <div>Loading...</div>; // Simple loading state

    if (!isAuthenticated) {
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user?.role)) {
        // User logged in but unauthorized for this role
        // Redirect to their default dashboard or access denied type page
        // For now, redirect to auth to keep it simple, or home
        return <Navigate to="/auth" replace />; 
    }

    return <Outlet />;
};
